import MemorySources from "./MemorySources";

export default MemorySources;
